import ManageUsers from "../views/admin/ManageUsers.vue";
import ManageCompanies from "../views/admin/ManageCompanies.vue";
import ManageTests from "../views/admin/ManageTests.vue";
import TestList from "../views/admin/TestList.vue";
import TestDetails from "../views/admin/TestDetails.vue";
import Reporting from "../views/admin/Reporting.vue";

//import personnelRecordRoutes from "@/routes/personnel-record-routes.js";
//import assetRoutes from "@/routes/asset-routes.js";

const adminRoutes = [
  {
    path: "/reporting",
    name: "reporting",
    component: Reporting,
    meta: {
      requiresAuth: ["ADM", "SEC"],
      title: "Reporting",
      navbarTitle: "Reporting",
      navbarIcon: "mdi-clipboard-list"
    }
  },
  {
    path: "/manageUsers",
    name: "users",
    component: ManageUsers,
    meta: {
      requiresAuth: ["ADM"],
      title: "Manage Users",
      navbarTitle: "Manage Users",
      navbarIcon: "mdi-account-group"
    }
  },
  {
    path: "/manageCompanies",
    name: "companies",
    component: ManageCompanies,
    meta: {
      requiresAuth: ["ADM"],
      title: "Manage Companies",
      navbarTitle: "Manage Companies",
      navbarIcon: "mdi-briefcase"
    }
  },
  {
    path: "/manageInductions",
    component: ManageTests,
    name: "manageInductions",
    meta: {
      navbarTitle: "Manage Inductions",
      navbarIcon: "mdi-video-vintage"
    },
    children: [
      {
        path: "",
        name: "manageInductions",
        component: TestList,
        props: { testId: "" },
        meta: { title: "Manage Inductions", requiresAuth: ["ADM"] }
      },
      {
        path: "testDetails/:testId",
        name: "testDetails",
        component: TestDetails,
        props: { testId: "" },
        meta: { title: "Manage Inductions", requiresAuth: ["ADM"] }
      }
    ]
  }
];

export default adminRoutes;
